module.exports = __webpack_public_path__ + "static/orlando-b77c2935060d1f3a09de265cbfcf8504.png";